import React from "react";

import { Transition } from "react-transition-group";
import { useOnClickOutside } from "@avamae/hooks";

// Icons
import Cross from "../../assets/Icon_Modal_Cross.png";
import ReactDOM from "react-dom";

type ModalProps = {
  open?: boolean;
  closeModal(): void;
  className?: string;
  backgroundClassName?: string;
  actionButton?: React.ReactNode;
  title: string;
  fullSize?: boolean;
  disableFooter?: boolean;
  customCloseButton?: React.ReactNode;
  customFooterButtons?: React.ReactNode;
  cancelBtnText?: string;
  closeOnClickOutside?: boolean;
  children: React.ReactNode | React.ReactNode[];
};

type Props = ModalProps;

const Modal: React.FC<Props> = ({
  children,
  open,
  closeModal,
  title,
  actionButton,
  fullSize,
  disableFooter,
  customCloseButton,
  customFooterButtons,
  backgroundClassName,
  className,
  cancelBtnText,
  closeOnClickOutside = true,
}) => {
  const [delayedOpen, setDelayedOpen] = React.useState(false);
  React.useEffect(() => {
    if (open) {
      setTimeout(() => {
        setDelayedOpen(true);
      }, 1);
    }
  }, [open]);
  const bind = useOnClickOutside(() => {
    closeOnClickOutside && closeModal();
  }, true);

  const portalContent = (
    <Transition
      in={open && delayedOpen}
      timeout={100}
      mountOnEnter
      unmountOnExit
    >
      {state => (
        <div className={`ModalUnderlay ${state} ${backgroundClassName || ""}`}>
          <div
            className={`${fullSize ? "Modal FullSize" : "Modal"} ${className ||
              ""}`}
            {...bind}
          >
            <div className="Inner">
              {/* Modal Header START */}
              <div className="Top">
                <h2 className="Title">{title}</h2>
                {customCloseButton ? (
                  customCloseButton
                ) : (
                  <div className="Cross">
                    <img src={Cross} alt="Cross" onClick={closeModal} />
                  </div>
                )}
              </div>
              {/* Modal Header END */}

              {/* Modal Content START */}
              <div className="Content">{state === "entered" && children}</div>
              {/* Modal Content END */}

              {/* Modal Footer START */}
              {disableFooter ? (
                <></>
              ) : customFooterButtons ? (
                customFooterButtons
              ) : (
                <div className="Buttons">
                  {actionButton ? (
                    <>
                      <button
                        className="Btn BtnCancel"
                        onClick={() => closeModal()}
                        type="button"
                      >
                        {cancelBtnText ?? "Cancel"}
                      </button>
                      {actionButton}
                    </>
                  ) : (
                    <>
                      <button
                        className="Btn BtnCancel"
                        onClick={closeModal}
                        type="button"
                      >
                        Cancel
                      </button>
                      <button
                        className="Btn"
                        onClick={closeModal}
                        type="submit"
                      >
                        Close
                      </button>
                    </>
                  )}
                </div>
              )}
              {/* Modal Footer END */}
            </div>
          </div>
        </div>
      )}
    </Transition>
  );

  const modalPortal = document.getElementById("modal-portal");
  if (modalPortal) {
    return ReactDOM.createPortal(portalContent, modalPortal);
  }

  return null;
};

export { Modal };
